<script lang="ts" setup>
import { inject, onMounted } from "vue";

withDefaults(
  defineProps<{
    label: string;
    icon: string;
    divider?: boolean;
  }>(),
  {
    divider: true,
  },
);

const tableFilterSymbol = inject<symbol>("tableFilterSymbol");

onMounted(() => {
  if (!tableFilterSymbol) {
    throw new Error("TableFilterRow must be a child of TableFilter");
  }
});
</script>

<template>
  <v-row>
    <v-col :style="{ flex: label ? '0 0 180px' : '0' }" class="d-flex align-center">
      <v-icon :icon="icon" />

      <span v-if="label" class="ml-2">
        {{ label }}
      </span>
    </v-col>
    <slot></slot>
  </v-row>
  <v-divider v-if="divider" class="mt-4 mb-4" />
</template>

<style lang="scss" scoped></style>
